export default {
  namespaced: true,
  state: {
    list: [],
    add: false,
    edit: false,
    editObj: {},
    delete: false,
    deleteObj: {},
  },
  getters: {
    list: state => state.list,
    add: state => state.add,
    edit: state => state.edit,
    editObj: state => state.editObj,
    delete: state => state.delete,
    deleteObj: state => state.deleteObj,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
    addMutate(state, data) {
      state.add = data;
    },
    editMutate(state, data) {
      state.edit = data;
    },
    editObjMutate(state, data) {
      state.editObj = data;
    },
    deleteMutate(state, data) {
      state.delete = data;
    },
    deleteObjMutate(state, data) {
      state.deleteObj = data;
    },
  },
  actions: {

    setList(context, data) {
      context.commit('listMutate', data);
    },

    setAdd(context, data) {
      context.commit('addMutate', data);
    },

    setEdit(context, data) {
      context.commit('editMutate', data);
    },
    setEditObj(context, data) {
      context.commit('editObjMutate', data);
    },

    setDelete(context, data) {
      context.commit('deleteMutate', data);
    },
    setDeleteObj(context, data) {
      context.commit('deleteObjMutate', data);
    },
  },
};
